import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import Accordion from './Accordion';
import Tab from './Tab';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import DropDownMenu from './DropDownMenu';
import BlockLink from './BlockLink';
import Gmap from './Gmap';
import bowser from 'bowser';
import matchheight from 'jquery-match-height';
import swiper_js from 'swiper';
import remodal from 'remodal';
import inview from 'jquery-inview';
import lightbox from 'lightbox2';


if (bowser.msie === true) {
	let version = 'ie_' + Math.floor(bowser.version);
	$('body').addClass('ie ' + version);
} else if (bowser.msedge === true) {
	$('body').addClass('edge');
} else if (bowser.firefox === true) {
	$('body').addClass('ff');
} else if (bowser.tablet === true) {
	$('body').addClass('tablet');
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "win7";
} else {
	os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
//通常盤
let param = {
	target: '#spnavi',
	trigger: '.btn_sp_navi',
	filter: 'resposive_flg',
	speed: 200
};

let spnav_accordion_1 = (scroller) => {
	$('.click-sp-nav-js').off();
	$('.click-sp-nav-js').on('click', function () {
		let target = $(this).find('.sp-nav-child');
		if (target.css('display') == 'none') {
			target.slideDown(500);
			scroller.refresh();
		} else {
			target.slideUp(500);
			scroller.refresh();
		}
		setTimeout(function () {
			scroller.refresh();
		}, 550);
	});
}

const spnavi = new SpNavi(param);
spnavi.exec(spnav_accordion_1);

//execに可変引数で処理を渡してナビの開閉時に処理させるサンプル
//例として、SPナビでアコーディオンを開くたびにiScrollをリセットする
// let spnav_accordion_1 = (scroller)=>{
// 	$('#scroller .inner > ul > li > span').off();
// 	$('#scroller .inner > ul > li > span').on('click',function(){
// 		let $parent = $(this).parent('li');
// 		let $child = $(this).next('.gnavi-child');
// 		let status = $child.css('display');

// 		if(status == 'block'){
// 			$child.slideUp(300,function(){
// 				scroller.refresh();
// 			});
// 			$parent.removeClass('active');
// 		}else{
// 			$child.slideDown(300,function(){
// 				scroller.refresh();
// 			});
// 			$parent.addClass('active');
// 		}

// 		return false;
// 	});
// }
// spnavi.exec(spnav_accordion_1);
/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();

/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop('#totop', '#global_footer', 100, 400);
totop.exec();

/**
 * 外部リンク・PDF・Word・Exlsに_blankの自動付与
 *
 */
const link_icon = require('./link_icon');
link_icon();
/* ===============================================
DropDown

markp:
<ul>
	<li>
		<a href=""></a>
		<ul class="child">
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
		</ul>
	</li>
	<li>
		<a href=""></a>
	</li>
	<li>
		<a href=""></a>
	</li>
</ul>
=============================================== */
// const dd = new DropDownMenu('ul li','.child',200);
// dd.exec();
/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
// const ac = new Accordion($('dt'));
// ac.exec();
/* ===============================================
Tab

markup:
<div class="tc">
	<ul>
		<li>tab1</li>
		<li>tab2</li>
		<li>tab3</li>
	</ul>
	<div class="tc_content">
		tabcon1tabcon1tabcon1tabcon1tabcon1tabcon1
	</div>
	<div class="tc_content">
		tabcon2tabcon2tabcon2tabcon2tabcon2tabcon2
	</div>
	<div class="tc_content">
		tabcon3tabcon3tabcon3tabcon3tabcon3tabcon3
	</div>
</div>
=============================================== */
// const tab = new Tab('.tc li','.tc .tc_content');
// tab.exec();

// /* gmap
// ----------------------- */
// let gmap = new Gmap();
// $(window).on('load',function(){
// 	gmap.exec();
// });

/* ===============================================
instagram with infinityScroll

markup:
<div class="slide--instagram_wrapper" id="insragram">
	<div class="slide--instagram">
		<div id="js-slide--instagram">
			<ul class="inner"></ul>
		</div>
	</div>
</div>
=============================================== */
/**
 *
 * @param {sring} requet_url instagramのリクエストURL ./_instagram_template.htmlにhtmlテンプレートサンプルあり
 * @param {element} append_target 読み込んだ写真を追加する要素
 * @param {element} slide_target スライドショーさせる要素
 */
// const instagram = require('./instagram');
// instagram('request_url','#js-slide--instagram .inner','#js-slide--instagram');



/*telリンクのPC無効化*/
if (bowser.mobile === true) {
	$('body').addClass('device--mobile');
	if (bowser.android === true) {
		$('body').addClass('device--mobile--android');
	}
} else {
	$('.js-tel-link').on('click', () => {
		return false;
	});
}

//js-inviewのクラスを追加
$('.js-inview-fadein').on('inview', function (event, isInView, visiblePartX, visiblePartY) {
	$(this).addClass('active');
});


//sub-headerがスクロールするとfixedする処理
if (document.getElementById('js-target') != null) {
	const navPos = $('#js-target').offset().top;
	const navHeight = $('#js-target').outerHeight();
	const target = navPos - navHeight;
	$(window).on('scroll', function () {
		if ($(this).scrollTop() > target) {
			$('#js-target').addClass('change-color');
		} else {
			$('#js-target').removeClass('change-color');
		}
	});
}


//headerがスクロールするとfixedする処理
const header_scr_fixed = function(header) {
	const header_height = $(header).height(); /*ガタつき防止のためheaderの高さを取得*/
	const scrollY = 300;/*headerがfixedする値(px)*/
	const haeder_scr = 'header-scr';
	$(window).scroll(function () {
			if ($(window).scrollTop() >= scrollY) {
				header.addClass(haeder_scr);
				$('.contents-inner').css('margin-top',header_height);
			} else {
				header.removeClass(haeder_scr);
				$('.contents-inner').css('margin-top','0px');
			}
	});
};
$(window).on('load resize', function() {
	if ((navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1) || navigator.userAgent.indexOf('iPod') > 0 || navigator.userAgent.indexOf('Android') > 0) {
		const header = $('#header-nav-sp');
		header_scr_fixed(header);
	}else{
		const header = $('#header-nav');
		header_scr_fixed(header);
	}
});

//header-navのホバー時の処理
$('.mouse-on-js').hover(function () {
	let target_child = $(this).find('.main-nav-child');
	$(target_child).addClass('mod-mouse-on');
}, function () {
	let target_child = $(this).find('.main-nav-child');
	$(target_child).removeClass('mod-mouse-on');
})
$(window).on('load', function () {
	//mv-Swiperのオプション
	let mv_swiper_container = new Swiper('.mv-swiper-container', {
		autoplay: 4000,
		// loop: true,
		slidesPerView: 1,
		effect: 'fade',
		speed: 2000,
		centeredSlides: true,
		spaceBetween: 0,
		pagination: '.mv-swiper-pagination',
		paginationClickable: true
	})
	//works-Swiperのオプション
	let works_sldier = new Swiper('.works-swiper-container', {
		loop: true,
		slidesPerView: 'auto',
		spaceBetween: 0,
		nextButton: '.swiper-button-next',
		prevButton: '.swiper-button-prev'
	})
	//built-Swiperのオプション
	let built_sldier = new Swiper('.built-swiper-container', {
		loop: true,
		slidesPerView: 'auto',
		spaceBetween: 10,
		nextButton: '.swiper-button-next',
		prevButton: '.swiper-button-prev'
	})
	//SP-swiperのオプションセット
	let parm_sp_swiper = {
		loop: true,
		slidesPerView: 1,
		centeredSlides: true,
		spaceBetween: 0,
		nextButton: '.swiper-button-next',
		prevButton: '.swiper-button-prev'
	};
	let works_sp_swiper = {
		loop: true,
		slidesPerView: 2,
		// centeredSlides: true,
		spaceBetween: 20,
		nextButton: '.swiper-button-next',
		prevButton: '.swiper-button-prev'
	};
	let built_sp_sldier = new Swiper('.built-sp-swiper-container', parm_sp_swiper);
	let works_sp_sldier = new Swiper('.works-sp-swiper-container', works_sp_swiper);
	//comapny-Swiperのオプション
	let company_swiper_container = new Swiper('.company-swiper-container', {
		autoplay: 4000,
		loop: true,
		slidesPerView: 'auto',
		effect: 'fade',
		speed: 1000,
		centeredSlides: true,
		spaceBetween: 0,
		pagination: '.company-swiper-pagination',
		paginationClickable: true
	})
	let param_js_has_text_transform_box_swiper_container = {
		autoplay: 4000,
		loop: true,
		effect: 'fade',
		slidesPerView: 'auto',
		speed: 1000,
		centeredSlides: true,
		spaceBetween: 0,
		paginationClickable: true,
		pagination: '.has-text-transform-box-swiper-pagination'
	};
	let js_has_text_transform_box_swiper_container = new Swiper('.js-has-text-transform-box-swiper-container', param_js_has_text_transform_box_swiper_container)
	let js_has_text_transform_box_swiper_container_2 = new Swiper('.js-has-text-transform-box-swiper-container_2', param_js_has_text_transform_box_swiper_container)
	//article-page メイン表示されるSwiper
	let article_swiper_container_main = new Swiper('.article-swiper-container-main', {
		slidesPerView: 1,
		effect: 'fade',
		speed: 0,
		spaceBetween: 0
	})
	//article-page サムネイルのSwiper
	let article_swiper_container_thumb = new Swiper('.article-swiper-container-thumb', {
		slideToClickedSlide: true,
		speed: 0,
		spaceBetween: 0,
		paginationClickable: true,
		virtualTranslate: true
	})

	article_swiper_container_main.params.control = article_swiper_container_thumb;
	article_swiper_container_thumb.params.control = article_swiper_container_main;


	$('.article-swiper-container-thumb').find('.swiper-slide:nth-child(-n+9)').addClass('page1');
	$('.article-swiper-container-thumb').find('.swiper-slide:nth-child(n+10)').addClass('page2');

	const Pager_Page1 = $('.pagination.page1');
	const Pager_Page2 = $('.pagination.page2');
	const Swiper_Page1 = $('.swiper-slide.page1');
	const Swiper_Page2 = $('.swiper-slide.page2')
	const Swiper_Prev = $('.swiper-pager').children('.prev');
	const Swiper_Next = $('.swiper-pager').children('.next');

	Pager_Page1.addClass('active');
	Swiper_Page1.addClass('active');


	/*class="page1" がアクティブの時*/
	const param_page_1_active = () => {
		Pager_Page1.addClass('active');
		Pager_Page2.removeClass('active');
		Swiper_Page1.addClass('active');
		Swiper_Page2.removeClass('active');
	}
	/*class="page2" がアクティブの時*/
	const param_page_2_active = () => {
		Pager_Page1.removeClass('active');
		Pager_Page2.addClass('active');
		Swiper_Page1.removeClass('active');
		Swiper_Page2.addClass('active');
	}
	/*swiper矢印を押した時の挙動*/
	Swiper_Prev.on('click', function () {
		if (Pager_Page1.hasClass('active')) {
			param_page_2_active();
		} else {
			param_page_1_active();
		}
	});
	Swiper_Next.on('click', function () {
		if (Pager_Page2.hasClass('active')) {
			param_page_1_active();
		} else {
			param_page_2_active();
		}
	});
	/*pagerをクリックした時の挙動*/
	Pager_Page1.on('click', function () {
		if (Pager_Page2.hasClass('active')) {
			param_page_1_active();
		}
	});
	Pager_Page2.on('click', function () {
		if (Pager_Page1.hasClass('active')) {
			param_page_2_active();
		}
	});
	//  END  article-page サムネイルのSwiper

	//google-map
	$('.js-map').each(function () {
		let op = {
			target: $(this).attr('id'),
			center: {
				lat: $(this).data('lat'),
				lng: $(this).data('lng')
			},
			pins: {
				lat: $(this).data('lat'),
				lng: $(this).data('lng')
			},
			settings: {
				zoom: 17,
				title: 'map'
			}
		};
		let parent = $(this).parent();
		if ($(this).data('style') == false) {
			op.styles = false;
		} else if (parent.hasClass('mod-openhouse')) {
			op.settings.icon = theme_path + '/assets/build/images/ico_openpin.png';
		} else {
			op.settings.icon = theme_path + '/assets/build/images/ico_pin.png';
		}
		if ($(this).data('zoom') > 0) {
			op.settings.zoom = $(this).data('zoom');
		}
		let gmap = new Gmap(op);
		gmap.exec();
	});

	//works-swiperホバー時の処理
	$('.mask-parent-js').hover(
		function () {
			$(this).addClass('hover-on');
		},
		function () {
			$(this).removeClass('hover-on');
		}
	);
	//
	const swiper_slide_img = $('.works-swiper-container.mod-toggle-slide').find('.swiper-slide-active').find('.swiper-slide-img');
	$(swiper_slide_img).addClass('click-on');
	//クリック時の処理　　VIEWマスクをの付け外し
	const mask_view = () => $('.swiper-slide-img.mask-parent-js').on('click', function () {
		const click_on = $('.swiper-slide-img.mask-parent-js.click-on'); /*VIEWがついてる要素があれば取得*/
		$(click_on).removeClass('click-on');
		$(click_on).find('.mask-child-js').css('opacity', '');
		$(this).addClass('click-on');
		$(this).find('.mask-child-js').css('opacity', '0');
	});

	//works-swiperクリック時の処理　　クリックしたコンテンツをパネルに表示する。
	$('.swiper-slide-img.mask-parent-js').on('click', function () {
		mask_view();
		const elements_to_active = $('.works-pickup-wrap.active'); /*現在アクティブになっている要素を取得する。*/
		const swiper_slide_img_data_value = $(this).attr('data-slide');  /*クリックしたswiper-slide-imgのdata属性を取得*/
		const works_pickup_wrap_el = $('.works-pickup-wrap');
		works_pickup_wrap_el.each(function (index) {
			const works_pickup_wrap_el_list = works_pickup_wrap_el[index];
			const works_pickup_wrap_data = $(works_pickup_wrap_el_list).attr('data-pickup-wrap');
			if (works_pickup_wrap_data == swiper_slide_img_data_value) {
				$(elements_to_active).removeClass('active');
				$(works_pickup_wrap_el_list).addClass('active');
			}
		});
	});
	//built-swiperクリック時の処理　　クリックしたコンテンツをパネルに表示する。
	$('.swiper-slide-img.mask-parent-js').on('click', function () {
		mask_view();
		const elements_to_active = $('.built-pickup-wrap.active'); /*現在アクティブになっている要素を取得する。*/
		const swiper_slide_img_data_value = $(this).attr('data-slide');  /*クリックしたswiper-slide-imgのdata属性を取得*/
		const works_pickup_wrap_el = $('.built-pickup-wrap');
		works_pickup_wrap_el.each(function (index) {
			const works_pickup_wrap_el_list = works_pickup_wrap_el[index];
			const works_pickup_wrap_data = $(works_pickup_wrap_el_list).attr('data-pickup-wrap');
			if (works_pickup_wrap_data == swiper_slide_img_data_value) {
				$(elements_to_active).removeClass('active');
				$(works_pickup_wrap_el_list).addClass('active');
			}
		});
	});
	//built_reformのext-icon-itemの高さ自動調
	$('.ext-icon-item-js-match-height').matchHeight();

	//tab切り替え
	$('.tab_realestate_top_title.mod-pattern-1').on('click', function () {
		$(this).css('background-color', '#fff');
		$('.tab_realestate_top_title.mod-pattern-2').css('background-color', 'inherit');
		$('.tab_realestate_top_contents.mod-pattern-1').addClass('active');
		$('.tab_realestate_top_contents.mod-pattern-2').removeClass('active');
	});
	$('.tab_realestate_top_title.mod-pattern-2').on('click', function () {
		$(this).css('background-color', '#fff');
		$('.tab_realestate_top_title.mod-pattern-1').css('background-color', 'inherit');
		$('.tab_realestate_top_contents.mod-pattern-2').addClass('active');
		$('.tab_realestate_top_contents.mod-pattern-1').removeClass('active');
	});
});


$(function () {
	$('.sidebar-arc-list-year').on('click', function () {
		if ($(this).next('.sidebar-arc-list-month-wrap').length) {
			if ($(this).hasClass('mod-on')) {
				$(this).removeClass('mod-on');
				$(this).next('.sidebar-arc-list-month-wrap').slideUp();
			} else {
				$(this).addClass('mod-on');
				$(this).next('.sidebar-arc-list-month-wrap').slideDown();
			}
		}
	});
});

$(window).on('load', function () {
	$(function () {
		$('.question-area').each(function () {
			const setBtn = $(this).find('.button-questions');
			const trimElm = $(this).find('.question-area-answer-content-text.mod-trim');
			const trimElm_height = trimElm.height();
			const mainElm = $(this).find('.question-area-answer-content-text.mod-main');
			const mainElm_height = mainElm.height();
			const anserElm = $(this).find('.question-area-answer-content');
			$(anserElm).css('height', trimElm_height);
			setBtn.on('click', function () {
				if ($(this).hasClass('mod-brown')) {
					$(this).removeClass('mod-brown');
					$(this).addClass('mod-white');
					$(this).find('span').text('閉じる');
					$(anserElm).css('height', mainElm_height);
					$(trimElm).fadeOut();
					$(mainElm).fadeIn();
				} else if ($(this).hasClass('mod-white')) {
					$(this).removeClass('mod-white');
					$(this).addClass('mod-brown');
					$(this).find('span').text('もっと見る');
					$(trimElm).fadeIn();
					$(mainElm).fadeOut();
					$(anserElm).css('height', trimElm_height);
				}
			});
		});
	});
});

//built_allのテーブル　最後の列のボーダーを削除
$(window).on('load', function () {
	let built_all_tbcount = $('.built_all-table').length;
	if (built_all_tbcount % 2 == 0) {
		$('.built_all-table:nth-last-of-type(-n+2)').addClass('pc-bd-bottom-none');
		$('.built_all-table:nth-last-of-type(-n+1)').addClass('pc-bd-bottom-none');
	} else {
		$('.built_all-table:nth-last-of-type(-n+1)').addClass('pc-bd-bottom-none');

	}
});

const tab_nav = $(".js-tab-nav");
const tab_content = $(".js-tab-content");
if (tab_nav.length && tab_content.length) {
	tab_nav.on('click', function () {
		const index = tab_nav.index(this);
		console.log(index);
		tab_nav.removeClass("is-active")
		tab_nav.eq(index).addClass("is-active")

		tab_content.removeClass("is-active")
		tab_content.eq(index).addClass("is-active")
	})


}

// divタグカスタムデータ
window.addEventListener('DOMContentLoaded', function (e) {
	[].forEach.call(document.querySelectorAll('[data-href]'), function (x) {
		x.addEventListener('click', function (e) {
			location.href = x.dataset["href"];
		});
	});
});

// modal
$(function () {
	$("#js-modalImage").click(function () {
		$("#js-modal").html($(this).prop('outerHTML'));
		$("#js-modal").fadeIn(200);
		$('body').css('overflow-y', 'hidden'); 
	});
	$("#js-modal, #js-modal div").click(function () {
		$("#js-modal").fadeOut(200);
		$('body').css('overflow-y','auto');   
	});
});